import React, { Component } from 'react';
import Login from '../HeaderMenu/Login/Login';
import LoginIcon from '../../Icons/Login';
import Link from '../../Link/Link';

import '../HeaderMenu/Login/Login.scss';
import { css } from '@emotion/core';
import lightOrDark from '../../SlickArrow/colorArrowFunction';

class LoginRegister extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLogin: false,
    };
  }

  // LOGIN
  toggleLogin = event => {
    event.preventDefault();

    this.setState({
      showLogin: !this.state.showLogin,
    });
  };

  closeLogin = event => {
    this.setState({
      showLogin: false,
    });
  };

  render() {
    const { showLogin } = this.state;
    const {
      user,
      isAuthenticated,
      onLogin,
      loginError,
      primaryColor,
      createUser,
      hasFacebookLogin,
      simple,
    } = this.props;

    const loginStyle = css`
      .login-icon {
        width: 32px;
        height: 32px;
        background-color: #f8f8f8;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          width: 24px;
          height: 24px;
          path {
            fill: ${primaryColor};
          }
        }
      }
    `;

    return (
      <nav className="navbar navbar-expand-sm navbar-right p-0">
        {!isAuthenticated ? (
          <Login
            simple={simple}
            user={user}
            isAuthenticated={isAuthenticated}
            onLogin={onLogin}
            showLogin={showLogin}
            onToggleLogin={this.toggleLogin}
            onCloseLogin={this.closeLogin}
            onCloseAll={this.closeLogin}
            loginError={loginError}
            primaryColor={primaryColor}
            onLoginFacebook={this.props.onLoginFacebook}
            facebookAppId={this.props.facebookAppId}
            hasFacebookLogin={hasFacebookLogin}
            createUser={createUser}
          />
        ) : (
          <Link to="/profilo">
            <div
              css={loginStyle}
              style={{ display: 'flex', alignItems: 'center', gap: 8 }}
            >
              <div className="login-icon">
                <LoginIcon fill={primaryColor} />
              </div>
              <div
                className="desktop"
                style={{
                  color:
                    lightOrDark(primaryColor) === 'dark' ? 'white' : '#666',
                }}
              >
                Ciao {user && user.billing && user.billing.firstname}
              </div>
            </div>
          </Link>
        )}
      </nav>
    );
  }
}

export default LoginRegister;
